exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3g3WLiLJzrxN5FOFri4o3B{height:1px}html[dir] ._3g3WLiLJzrxN5FOFri4o3B{background:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}", ""]);
// Exports
exports.locals = {
	"bottomBorder": "_3g3WLiLJzrxN5FOFri4o3B"
};